var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInbox = function SvgInbox(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.256 15.419v3.279c0 .578.468 1.046 1.046 1.046h13.396c.578 0 1.046-.468 1.046-1.046v-3.28h-4.348c-.155 2.044-1.14 2.791-3.396 2.791-2.208 0-3.227-.807-3.394-2.79h-4.35zm5.581-.628c0 1.744.425 2.162 2.163 2.162 1.795 0 2.163-.35 2.163-2.162 0-.347.28-.628.628-.628h5.581c.347 0 .628.28.628.628v3.907A2.302 2.302 0 0 1 18.698 21H5.302A2.302 2.302 0 0 1 3 18.698V14.79c0-.347.281-.628.628-.628h5.581c.347 0 .628.28.628.628zm-5.647.28a.628.628 0 1 1-1.124-.561l1.86-3.721a.628.628 0 1 1 1.124.562l-1.86 3.72zm13.691-6.63h-4.02a.628.628 0 0 1-.628-.627V4.256h-6.07c-.578 0-1.047.468-1.047 1.046v9.463a.628.628 0 1 1-1.255 0V5.302A2.302 2.302 0 0 1 7.163 3h6.064c.14 0 .28.013.417.038a.627.627 0 0 1 .769.29c.121.074.236.158.343.254l3.61 3.209c.15.132.278.28.387.443a.628.628 0 0 1 .34.817c.03.15.046.305.046.46v2.41l1.795 3.589a.628.628 0 0 1-1.124.562l-.67-1.342v1.06a.628.628 0 1 1-1.256 0V8.511l-.003-.07zm-.96-1.255-2.433-2.163v2.163h2.433z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inbox.b328b1fb2483d87a6e24c088aeccc2d2.svg";